import { deepClone } from '@zz-yp/hunter-js-utils'

const state = {
  brandList: [],
  modelList: []
}

const mutations = {
  // 设置品牌列表
  SET_BRAND_LIST: (state, payload) => {
    state.brandList = payload
    state = deepClone(state)
  },

  // 设置型号列表
  SET_MODEL_LIST: (state, payload) => {
    state.modelList = payload
    state = deepClone(state)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
